import { Routes, Route } from 'react-router-dom'
import AuthCallback from '@/views/AuthCallback'
import LoginRedirect from '@/views/LoginRedirect'
import Suggestions from '@/views/Suggestions'
import Voting from '@/views/Voting'
import Survey from '@/views/Survey'
import NotFound from '@/views/NotFound'
import ProtectedRoute from '@/components/layout/ProtectedRoute'
import RootRedirect from '@/components/layout/RootRedirect'

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<RootRedirect />} />
      <Route path="/auth" element={<LoginRedirect />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route
        path="/suggestions"
        element={
          <ProtectedRoute>
            <Suggestions />
          </ProtectedRoute>
        }
      />
      <Route
        path="/voting"
        element={
          <ProtectedRoute>
            <Voting />
          </ProtectedRoute>
        }
      />
      <Route
        path="/survey"
        element={
          <ProtectedRoute>
            <Survey />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}
